<template>
  <div class="picture" id="picture">
    <my-header />

    <!-- 安装说明书 -->

    <div class="installMain clear">
      <div class="installLeft left">
        <p class="p1">资料下载</p>
        <p class="p2">
          <router-link to="/installation">安装说明书</router-link>
        </p>
        <p class="p2">
          <router-link to="/clean">保养与清洁</router-link>
        </p>
        <p class="p2">
          <router-link to="/questions">常见问题</router-link>
        </p>
        <p class="p2">
          <router-link to="/picture">画册下载</router-link>
        </p>
      </div>
      <div class="installRight left">
        <div class="pre">
          <div class="allTitle">
            <span>画册下载</span>
          </div>
        </div>

        <div class="pre">
          <div class="direction">
            <p class="p1">单击封面可以下载查看目录的内容。</p>
            <p class="p2">
              您可以在这里面找到你所需要的产品或者灵感，然后电话告诉我们。
            </p>
          </div>
        </div>
        <div class="pre">
          <div class="insDetail">
            <b-container>
              <b-row>
                <b-col
                  cols="6"
                  xs="6"
                  sm="4"
                  md="4"
                  xl="4"
                  lg="4"
                  v-for="(currect, i) in dataList"
                >
                  <div class="rowImg">
                    <img :src="currect.imgPath" />
                    <div class="striping">
                      <p class="p1">{{ currect.name }}</p>
                      <p
                        class="p2"
                        v-on:click="downFile(currect.filePath, currect.name)"
                      >
                        点击&nbsp; <b-icon-cloud-download />&nbsp;下载
                      </p>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
      </div>
    </div>

    <my-footer />
  </div>
</template>

<script>
import myHeader from "@/views/myHeader.vue";
import myFooter from "@/views/myFooter.vue";

export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      dataList: []
    };
  },
  mounted() {
    if (this.$route.query.go) {
      document.querySelector("#" + this.$route.query.go).scrollIntoView(true);
    }

    let that = this;
    that.$axios
      .get(that.$global.baseURL + "/web/modules/getModulesByCatalogId.form", {
        params: {
          catalogId: "2"
        }
      })
      .then(res => {
        if (res.data.jsonArray == "error") {
          uni.showModal({
            title: res.data.errorInfo,
            showCancel: false
          });
        } else {
          that.dataList = res.data.dataList;
        }
      });
  },
  methods: {
    downFile(url, name) {
      let prefix = url.substring(url.lastIndexOf(".") + 1);
      window.location.target = "_ablank";
      window.location.href =
        this.$global.baseURL +
        "/web/fileupload/downloadFile2.form?filePath=" +
        url +
        "&fileName=" +
        name +
        "." +
        prefix;
    }
  }
};
</script>

<style>
.picture {
  width: 100%;
}

/*最外层 */
.pre {
  width: 90%;
}

.picture .pre .allTitle {
  width: 90%;
  text-align: center;
  margin: 0 auto;
  color: #8d8c8c;
  font-size: 53px;
  letter-spacing: 10px;
  font-weight: lighter;
  font-family: "microsoft yahei";
  padding-top: 50px;
  padding-bottom: 20px;
  /* padding: 25px 0; */
}

.picture .installLeft {
  width: 100px;
  margin-left: 80px;
  margin-top: 65px;
  letter-spacing: 2px;
}

.picture .installLeft .p1 {
  font-size: 18px;
  margin-bottom: 30px;
}

.picture .installLeft .p2 {
  font-size: 14px;
}

.picture .installLeft p {
  margin-top: -10px;
  color: #595757;
}

.picture .installLeft a {
  text-decoration: none;
  color: #595757;
}

.picture .installLeft a:hover {
  text-decoration: none;
  color: #ccb356;
}

.picture .installRight {
  width: -moz-calc(100% - 217px);
  width: -webkit-calc(100% - 217px);
  width: calc(100% - 217px);
}

.direction {
  width: 75%;
  margin: 0 auto;
  color: #595757;
  margin-top: 30px;
  letter-spacing: 1px;
}

.direction .p1 {
  font-size: 20px;
}

.direction .p2 {
  font-size: 14px;
}

.insDetail {
  width: 75%;
  margin: 0 auto;
  margin-top: 60px;
  margin-bottom: 20px;
}

.insDetail .container .row {
  margin-left: -45px;
}

.insDetail img {
  width: 85%;
  margin-bottom: 20px;
}

.insDetail .container .striping {
  border-top: 1px solid #c4c4c4;
  width: 70%;
  margin-top: 10px;
  margin-left: 18px;
}

.insDetail .container .striping p {
  text-align: center;
  color: #595757;
}

.insDetail .container .striping .p1 {
  font-size: 12px;
  margin-top: 18px;
  font-weight: bold;
  letter-spacing: 0.3px;
}

.insDetail .container .striping .p2 {
  font-size: 18px;
  margin-bottom: 75px;
  cursor: pointer;
}

/* 媒体查询 */
@media screen and (max-width: 850px) {
  .picture .installMain .installLeft {
    display: none;
  }

  .picture .installMain .installRight {
    width: 100%;
  }

  .picture .installMain .installRight .pre {
    width: 100%;
    margin: 0 auto;
  }

  .picture .installMain .installRight .allTitle {
  }

  .picture .installMain .installRight .direction {
    width: 90%;
    margin: 0 auto;
    margin-top: 30px;
    margin-left: 35px;
  }

  /* .container .row .rowImg img{
			width: 100%;
		} */

  .picture .insDetail img {
    margin-left: 17px;
  }

  .picture .insDetail .container .row {
    margin-left: -35px;
  }

  .picture .insDetail .container .striping {
    width: 81%;
  }
}
</style>
